import useSub from "@/components/layout/useSub";
import DODO_STATUS_TYPE from "@/constants/dodoStatusType";
import { useAuth } from "@/hooks/useAuth";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import useBillingMeter from "../../pages/account-settings/billingTab/useBillingMeter";
import useSendEvent from "../../pages/account-settings/billingTab/useSendEvent";

const TOTAL_TRIAL_CREDITS = Number(
  process.env.NEXT_PUBLIC_TOTAL_CREDIT_VALUE_TRIAL,
);

export default function useTokenTracking() {
  const router = useRouter();

  const { user, org } = useAuth();
  const { sendEvent } = useSendEvent();

  const [isBlocked, setIsBlocked] = useState(false);

  const isAllowedToFetchSubscription =
    user?.id &&
    router.pathname !== "/organization" &&
    router.pathname !== "/on-board";

  const { subscriptionData: subscription } = useSub(
    isAllowedToFetchSubscription === true,
  );

  const isTrial =
    subscription?.attributes?.dodo_status == DODO_STATUS_TYPE.trial;

  const { data: tokenUsage, isLoading: isFetchingBilling } =
    useBillingMeter(isTrial);

      const trackTokens = async (totalTokens) => {
        if (!totalTokens || !org) return;
    
        const maaranCredits = totalTokens / 1000;
        try {
    
          const meterName = isTrial
            ? process.env.NEXT_PUBLIC_TRIAL_METER_NAME
            : process.env.NEXT_PUBLIC_METER_NAME;
    
          const eventData = {
            event_id: crypto.randomUUID(),
            event_name: meterName,
            customer_id: org?.attributes?.customer?.id,
            timestamp: new Date().toISOString(),
            metadata: {
              totalToken: maaranCredits,
            },
          };
    
          sendEvent(eventData);
        } catch (error) {
          console.log(error);
        }
      };

  useEffect(() => {
    if (tokenUsage?.totalCreditsUsed && !isFetchingBilling) {
      const usedCredits = Math.floor(tokenUsage.totalCreditsUsed);

      if (isTrial) {
        if (usedCredits > TOTAL_TRIAL_CREDITS) {
          setIsBlocked(true);
        }
      }
    }
  }, [isFetchingBilling, tokenUsage]);

  return { isTrial, isBlocked, trackTokens };
}
